export enum InvoiceStatus {
    NEW = 'new',
    PAID = 'paid',
    CANCELED = 'canceled',
    PAID_PART = 'paid_part',
    EXPIRED = 'expired',
}